<template>
  <Modal :value="value" @input="closeModal" width="xl">
    <div slot="header">
      <h3>Detalhes da Indicacao #{{ indication.id }}</h3>
    </div>

    <div class="indication-detail" v-if="indication">

      <!-- Editar Status -->
      <div v-if="showForm">
        <Form
          :indication="indication"
          :driverIndicationStatuses="driverIndicationStatuses"
          @cancel="showForm = false"
          @saved="onSaved"
        />
      </div>

      <template v-else>
        <div class="mb-3">
          <button class="btn btn-primary btn-sm" @click="showForm = true">
            Editar Status
          </button>
        </div>

        <!-- Secao: DriverIndication -->
        <div class="ibox">
          <div class="ibox-title" @click="toggleSection('indication')" style="cursor: pointer">
            Indicacao
            <span class="float-right mr-3">
              <EyeIcon v-if="sections.indication.show" />
              <EyeOffIcon v-else />
            </span>
          </div>
          <div class="ibox-content" v-show="sections.indication.show">
            <p><strong>ID:</strong> {{ indication.id }}</p>
            <p><strong>Protocolo:</strong> {{ indication.protocol || '-' }}</p>
            <p><strong>Status:</strong> {{ getStatusName(indication) }}</p>
            <p><strong>Status ID:</strong> {{ indication.driverIndicationStatusId || indication.driver_indication_status_id || '-' }}</p>
            <p><strong>Conta ID:</strong> {{ indication.accountId || indication.account_id || '-' }}</p>
            <p><strong>Nome da conta:</strong> {{ getAccountName(indication) }}</p>
            <p><strong>Atualizado por:</strong> {{ indication.updatedBy || indication.updated_by || '-' }}</p>
            <p><strong>Processo externo ID:</strong> {{ indication.externalProcessId || indication.external_process_id || '-' }}</p>
            <p><strong>Ticket ID:</strong> {{ indication.ticketId || indication.ticket_id || '-' }}</p>
            <p><strong>Searchable:</strong> {{ indication.searchable || '-' }}</p>
            <p><strong>Criado em:</strong> {{ indication.createdAt || indication.created_at | datetime }}</p>
            <p><strong>Atualizado em:</strong> {{ indication.updatedAt || indication.updated_at | datetime }}</p>

            <div class="mt-2">
              <button class="btn btn-outline btn-sm" @click="sections.indication.showJson = !sections.indication.showJson">
                {{ sections.indication.showJson ? 'Ocultar JSON' : 'Ver JSON' }}
              </button>
              <div v-if="sections.indication.showJson" class="mt-2">
                <Panel :data="indication" :deep="2" />
              </div>
            </div>
          </div>
        </div>

        <!-- Secao: Ticket -->
        <div class="ibox">
          <div class="ibox-title" @click="toggleSection('ticket')" style="cursor: pointer">
            Multa (Ticket)
            <span class="float-right mr-3">
              <EyeIcon v-if="sections.ticket.show" />
              <EyeOffIcon v-else />
            </span>
          </div>
          <div class="ibox-content" v-show="sections.ticket.show">
            <template v-if="indication.ticket">
              <p><strong>ID:</strong> {{ indication.ticket.id || '-' }}</p>
              <p><strong>AIT:</strong> {{ indication.ticket.ait || '-' }}</p>
              <p><strong>Placa:</strong> {{ indication.ticket.plate || '-' }}</p>
              <p><strong>Renavam:</strong> {{ indication.ticket.renavam || '-' }}</p>
              <p><strong>Data da Infracao:</strong> {{ indication.ticket.occurredAt || indication.ticket.occurred_at | datetime }}</p>
              <p><strong>Prazo de Indicacao:</strong> {{ indication.ticket.indicationDeadline || indication.ticket.indication_deadline | datetime }}</p>
              <p><strong>Descricao:</strong> {{ indication.ticket.description || '-' }}</p>
              <p><strong>Local:</strong> {{ indication.ticket.local || '-' }}</p>
              <p><strong>Orgao Autuador:</strong> {{ indication.ticket.issuingAuthority || indication.ticket.issuing_authority || '-' }}</p>

              <div class="mt-2">
                <button class="btn btn-outline btn-sm" @click="sections.ticket.showJson = !sections.ticket.showJson">
                  {{ sections.ticket.showJson ? 'Ocultar JSON' : 'Ver JSON' }}
                </button>
                <div v-if="sections.ticket.showJson" class="mt-2">
                  <Panel :data="indication.ticket" :deep="2" />
                </div>
              </div>
            </template>
            <p v-else class="text-muted">Dados do ticket nao disponiveis</p>
          </div>
        </div>

        <!-- Secao: Driver -->
        <div class="ibox">
          <div class="ibox-title" @click="toggleSection('driver')" style="cursor: pointer">
            Motorista (Driver)
            <span class="float-right mr-3">
              <EyeIcon v-if="sections.driver.show" />
              <EyeOffIcon v-else />
            </span>
          </div>
          <div class="ibox-content" v-show="sections.driver.show">
            <template v-if="indication.driver">
              <p><strong>ID:</strong> {{ indication.driver.id || '-' }}</p>
              <p><strong>Nome:</strong> {{ indication.driver.name || '-' }}</p>
              <p><strong>CPF:</strong> {{ indication.driver.cpf || '-' }}</p>
              <p><strong>Telefone:</strong> {{ indication.driver.phone || '-' }}</p>

              <div class="mt-2">
                <button class="btn btn-outline btn-sm" @click="sections.driver.showJson = !sections.driver.showJson">
                  {{ sections.driver.showJson ? 'Ocultar JSON' : 'Ver JSON' }}
                </button>
                <div v-if="sections.driver.showJson" class="mt-2">
                  <Panel :data="indication.driver" :deep="2" />
                </div>
              </div>
            </template>
            <p v-else class="text-muted">Dados do motorista nao disponiveis</p>
          </div>
        </div>

        <!-- Secao: Historico -->
        <div class="ibox">
          <div class="ibox-title" @click="toggleSection('histories')" style="cursor: pointer">
            Historico
            <span class="float-right mr-3">
              <EyeIcon v-if="sections.histories.show" />
              <EyeOffIcon v-else />
            </span>
          </div>
          <div class="ibox-content" v-show="sections.histories.show">
            <Histories
              v-if="sections.histories.loaded"
              :indicationId="indication.id"
              :driverIndicationStatuses="driverIndicationStatuses"
            />
          </div>
        </div>
      </template>
    </div>

    <template slot="footer">
      <button class="btn btn-outline" @click="closeModal">Fechar</button>
    </template>
  </Modal>
</template>

<script>
import { EyeIcon, EyeOffIcon } from 'vue-feather-icons'
import Modal from '@/components/shares/specialTag/Modal'
import Panel from '@/components/admin/maestro/Panel'
import Form from './Form'
import Histories from './Histories'

export default {
  name: 'DriverIndicationShow',
  components: { EyeIcon, EyeOffIcon, Modal, Panel, Form, Histories },
  inject: ['getAccountName'],
  props: {
    value: { type: Boolean, default: false },
    indication: { required: true, type: Object },
    driverIndicationStatuses: { required: true, type: Array }
  },
  data: () => ({
    showForm: false,
    sections: {
      indication: { show: true, loaded: true, showJson: false },
      ticket: { show: false, loaded: false, showJson: false },
      driver: { show: false, loaded: false, showJson: false },
      histories: { show: false, loaded: false, showJson: false }
    }
  }),
  methods: {
    toggleSection(name) {
      this.sections[name].show = !this.sections[name].show
      if (this.sections[name].show) {
        this.sections[name].loaded = true
      }
    },
    getStatusName(indication) {
      const statusId = indication.driverIndicationStatusId || indication.driver_indication_status_id
      if (statusId && this.driverIndicationStatuses.length > 0) {
        const status = this.driverIndicationStatuses.find(s => s.id === statusId)
        return status ? `${status.name} (${status.code})` : statusId
      }
      return '-'
    },
    closeModal() {
      this.$emit('input', false)
      this.$emit('close')
    },
    onSaved() {
      this.showForm = false
      this.$emit('saved')
    }
  }
}
</script>

<style scoped>
</style>
